var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c('div',{staticClass:"map",attrs:{"id":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }